module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blank"
  }, [_c('group', {
    attrs: {
      "gutter": "8",
      "type": "hint"
    }
  }, [_c('cell', {
    attrs: {
      "height": "64"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/images/question.png"),
      "height": "22",
      "width": "21",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "value help-detail-title",
    attrs: {
      "slot": "value"
    },
    slot: "value"
  }, [_vm._v(_vm._s(_vm.title))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "help-answer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "help-detail",
    domProps: {
      "innerHTML": _vm._s(_vm.detail)
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/images/ask.png"),
      "height": "22",
      "width": "21",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dd4de0b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/helpdetail.vue
// module id = 198
// module chunks = 0